import React, { PropTypes } from 'react';
import FlatButton from 'material-ui/FlatButton';
import IconButton from 'material-ui/IconButton';
import Input from '../../../form/Input';
import { TwoColumnContentCell, TwoColumnContentClubCell } from '../../../../api/club-cms/content/two-column.content';
import TwoColumnsContentSimpleCell from './TwoColumnsContetnSimpleCell';
import TwoColumnsContentParticipantCell from './TwoColumnsContentParticipantCell';
import { IconDelete } from '../../../Icons';

/**
 * @property {TwoColumnContent} props.content
 */
class TwoColumnsContent extends React.Component {
  static propTypes = {
    content: PropTypes.object.isRequired,
    changeContent: PropTypes.func.isRequired
  };

  _addRow = () => {
    let { content, changeContent } = this.props;
    changeContent(content.addRow());
  };

  _changeLeftLabel = (data) => {
    let { content, changeContent } = this.props;
    changeContent(content.setLeftLabel(data));
  };

  _changeRightLabel = (data) => {
    let { content, changeContent } = this.props;
    changeContent(content.setRightLabel(data));
  };

  render() {
    let { content, changeContent } = this.props;

    return (
      <div style={{padding: 16}}>
      <table border="0">
        <thead>
        <tr>
          <th>
            <Input value={content.leftLabel} onChange={this._changeLeftLabel}/>
          </th>
          <th>
            <Input value={content.rightLabel} onChange={this._changeRightLabel}/>
          </th>
          <th></th>
        </tr>
        </thead>
        <tbody>
        { content.items.map(
          (row, index) => (
            <tr key={index} style={{verticalAlign: 'middle'}}>
              <td>
                {this.renderCell(
                  row.leftCell,
                  (cell) => changeContent(content.updateListItem(row, row.setLeftCell(cell)))
                )}
              </td>
              <td>
                {this.renderCell(
                  row.rightCell,
                  (cell) => changeContent(content.updateListItem(row, row.setRightCell(cell)))
                )}
              </td>
              <td>
                <IconButton onClick={() => changeContent(content.remove(row))} >
                  <IconDelete/>
                </IconButton>
              </td>
            </tr>
          )
        ) }
        </tbody>
      </table>
        <FlatButton label="Add 2 column content" onClick={this._addRow} />
      </div>
    );
  }

  renderCell(cell, update) {
    if (cell instanceof TwoColumnContentClubCell) {
      return (
        <TwoColumnsContentParticipantCell cell={cell} onUpdate={(value) => update(cell.update(value))} />
      );

    } else if (cell instanceof TwoColumnContentCell) {
      return (
        <TwoColumnsContentSimpleCell cell={cell} onUpdate={(value) => update(cell.setPrimaryText(value))} />
      );
    } else {
      throw 'whaaa';
    }
  }
}

export default TwoColumnsContent;



// WEBPACK FOOTER //
// ./src/components/ClubCMS/Content/TwoColumnContent/TwoColumnsContent.js